import { render } from "./DigitalLearningEcosystemView.vue?vue&type=template&id=c896ed66&scoped=true"
import script from "./DigitalLearningEcosystemView.vue?vue&type=script&lang=js"
export * from "./DigitalLearningEcosystemView.vue?vue&type=script&lang=js"

import "./DigitalLearningEcosystemView.vue?vue&type=style&index=0&id=c896ed66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c896ed66"]])

export default __exports__